import { Brand } from "../../../../types";
import styles from "./style.module.css";

type BrandCardProps = {
  popular_brand: Brand;
  onClick: () => void;
}

const BrandCard: React.FC<BrandCardProps> = (props) => {
  const {
    popular_brand,
    onClick
  } = props;

  return (
    <div className={styles.brandCard} onClick={onClick}>
      <img
        src={popular_brand.logo}
        alt="logo"
      />
    </div>
  );
};

export default BrandCard;